<template>
    <MainSlot :forceLogout="forceLogout">

        <!-- user ban -->
        <div v-if="user_ban" class="block_banned">
            <img src="../assets/img/user_banned.svg" alt="user banned">
            <div class="text">
                <div>Unfortunately,</div>
                <div>this account has been banned.</div>
            </div>
            <div @click="backToLogin"
                 class="btn"
            >
                Back to login
            </div>
        </div>

        <!-- login form -->
        <div v-else
             class="background_image_main center-card">
            <div class="card">
                <div class="card-content">
                    <h5>Login</h5>
                    <div class="input-field mb29">
                        <input
                            id="email"
                            ref="email"
                            v-model="user.email"
                            @keyup="setErrorMessage()"
                            @input="updateTextFields()"
                            type="text"
                        >
                        <label for="email" ref="email_label">Email</label>
                    </div>
                    <div class="input-field mb29">
                        <input id="password"
                               ref="password"
                               v-model="user.password"
                               @input="updateTextFields()"
                               type="password">
                        <label for="password" ref="password_label">Password</label>
                    </div>
                    <div class="error-message">
                        {{ error }}
                    </div>
                    <div class="btn_wrapper">
                        <button class="btn"
                                @click="handleSubmitLogin"
                        >LOGIN
                        </button>
                    </div>
                    <div class="buttons_wrapper_between bottom_links">
                        <router-link to="/registration" class="btn_link">Don’t have an account?</router-link>
                        <router-link to="/forgot-password" class="btn_link">Forgot password?</router-link>
                    </div>
                </div>
            </div>
        </div>

    </MainSlot>
</template>

<script>
import {isValidEmail} from "../services/validators";
import {mapMutations, mapActions} from 'vuex';
import firebase from "firebase/app";
import 'firebase/auth';
import {errorMessage} from "../services/messges";

export default {
    data() {
        return {
            forceLogoutProp: false,
            user: {
                email: '',
                password: ''
            },
            error: '',
            user_ban: false,
            updateTick: {
                interval_instance: null,
                repeat: 5
            }
        };
    },
    mounted() {
        this.checkLogged();
        this.updateTextFieldsTick();
    },
    methods: {
        ...mapMutations([
            "setLogged",
            "setLoginChecked",
            'setLoading',
            'login',
            'setUserInfo',
        ]),
        ...mapActions([
            'loadUserInfo'
        ]),
        async checkUserRegistration(user_data) {
            try {
                const {uid, email} = user_data
                const {data} = await this.$http.postAuth(`${this.$http.apiUrl()}auth/firebase-user/check`, {uid, email});
                const {user, token, ban, is_completed_registration} = data?.data || {};
                if (ban) {
                    this.user_ban = true;
                    return;
                }
                if (!is_completed_registration) {
                    await this.$router.push('/social-step-two');
                    return;
                }
                if (user && token) {
                    await this.login({user, token});
                    await this.setLoginChecked(true);
                    await this.$router.push('/events-app');
                } else {
                    throw new Error('Something went wrong...');
                }
            } catch (e) {
                const {response} = e;
                const status = response?.status || 400;
                if (status === 403) {
                    const code = response?.data?.error?.code || 4000;
                    if (code === 4003) {
                        this.user_ban = true;
                    }
                }
                errorMessage(e?.response?.data?.error?.message || 'Something went wrong...');
                console.error(e);
            }
        },
        backToLogin() {
            this.user_ban = false;
            this.$nextTick(_ => {
                this.updateTextFieldsTick()
            })
        },
        updateTextFields() {
            const right_bg = 'rgb(251, 252, 255)'.toLowerCase();
            let style_email = window.getComputedStyle(this.$refs.email);
            let style_password = window.getComputedStyle(this.$refs.password);
            M?.updateTextFields();
            if (style_email.backgroundColor.toLowerCase() !== right_bg || style_password.backgroundColor.toLowerCase() !== right_bg) {
                this.$refs.email_label.classList.add('active');
                this.$refs.password_label.classList.add('active');
            }
        },
        updateTextFieldsTick() {
            this.updateTick.repeat = 5;
            this.updateTextFields();
            this.updateTick.interval_instance = setInterval(() => {
                this.updateTextFields();
                --this.updateTick.repeat;
                if (this.updateTick.repeat <= 0) {
                    clearInterval(this.updateTick.interval_instance);
                    this.updateTick.interval_instance = null;
                }
            }, 1000)
        },
        async checkLogged() {
            try {
                if (localStorage.getItem('jwt')) {
                    await this.$http.refreshToken();
                    await this.$router.push('/events-app')
                }
            } catch (e) {

            }
        },
        async handleSubmitLogin() {
            if (!this.validateForm()) {
                return;
            }
            try {
                const {email, password} = this.user;
                const {user} = await firebase.auth().signInWithEmailAndPassword(email, password);
                await this.checkUserRegistration(user);
            } catch (e) {
                console.log(e);
                console.log(e?.message);
                this.setErrorMessage('Wrong email or password. Please, double-check and try again.');
            }
        },
        validateForm() {
            if (!isValidEmail(this.user.email)) {
                this.setErrorMessage('Invalid Email Format.');
                return null;
            }
            if (+this.user.password.length < 6 || +this.user.password.length > 20) {
                this.setErrorMessage('Password length must be between 6 and 20 characters.');
                return null;
            }
            return true;
        },
        setErrorMessage(msg = '') {
            if (this.error !== msg) {
                this.error = msg;
            }
        }
    },
    metaInfo: {
        title: 'Login Page',
        titleTemplate: '%s | Speed Friending Webapp'
    },
    beforeDestroy() {
        if (this.updateTick.interval_instance) {
            clearInterval(this.updateTick.interval_instance);
            this.updateTick.interval_instance = null;
        }
    },
    computed: {
        forceLogout() {
            return this.forceLogoutProp;
        }
    },
    name: "Login"
}
</script>

<style lang="scss" scoped>

.block_banned {
    cursor: default;
    width: 100%;
    max-width: 400px;
    margin: 100px auto 0px;
    text-align: center;

    .text {
        font-weight: bold;
        margin: 20px 0px;

        & div:nth-child(1) {
            font-size: 18px;
        }
    }
}

.btn_wrapper {
    .btn {
        font-weight: 700;
    }
}

.bottom_links {
    padding-top: 15px;
}

.mb29 {
    margin-bottom: 29px;
}

h5 {
    margin-bottom: 30px;
    text-align: center;
    font-weight: bold;
}
</style>
